import { render } from "./ModalChooseCustomer.vue?vue&type=template&id=529c5f45"
import script from "./ModalChooseCustomer.vue?vue&type=script&lang=js"
export * from "./ModalChooseCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__